import React, { useState, useEffect, useContext } from 'react'
import { useTranslation } from 'react-i18next';

import { mainContext } from '../../../MainContext';

function ContainerHead() {
  const { t } = useTranslation();


  useEffect(() => {
  }, [])


  return (
    <header>
      <img src={t('mainvisual.img')} alt="ピアノ教室経営 指導法オンラインサロン" />
    </header>
  );
}

export default ContainerHead;